/**
 * Created by portiz on 2/18/19.
 */
import React from 'react';
import {
    Card,
    Col,
    Row,
    CardBody,
    Button,
    Form
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import FormGroupPlan from '../forms/form-group-plan';
import CheckoutForm from '../stripe/stripe-card';
import FormRegistrationByAdmin from '../forms/form-admin-client-manager';
import {Elements, StripeProvider} from 'react-stripe-elements';
import Settings from '../../custom-classes/settings';
import ApiCalls from '../../custom-classes/api-calls';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import FileUploader from '../fileuploader/drop-zone.js';
import SessionManager from '../../custom-classes/session-manager';
import ModalCancellationSubscription from '../modals/modal-cancel-subscription';
import LanguageManager from '../../custom-classes/language-manager';

// Component for subscriptions
class FormSubscriptionCalculation extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.props.addTranslation(global);
        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            successfulRegistration: true,
            checked: false,
            lineChartData: null,
            languages: [],
            didMount: false,
            stripeApiKey: Settings.getStripeToken(),
            stripeUpdatePayment: false,
            subTokenStripe: null,
            userId: null,
            submitButtonAvailable: false,
            propsModal: null,
            subscriptionId : null,
            isEdit: false,
            isReadOnly: props.data.isReadOnly ? props.data.isReadOnly: false,
            showCancellationModal: false,
            disabledCancellation: false,
            cancelledInmediatetly: false,
            currencyIsoCode: props.data.currencyIsoCode ? props.data.currencyIsoCode : null,
            interval: props.data.interval ? props.data.interval : null,
            productId: props.data.productId ? props.data.productId : null,
            planName: props.data.planName ? props.data.planName : '',
            price: props.data.price ? props.data.price : null,
            validPrice: props.data.validPrice ? props.data.validPrice : false,
            tryPeriod: props.data.tryPeriod ? props.data.tryPeriod : null,
            isForSchoolChecked: props.data.isForSchoolChecked ? props.data.isForSchoolChecked : false,
            isPrivate: props.data.isPrivate ? props.data.isPrivate : false,
            studentQuantity: props.data.studentQuantity ? props.data.studentQuantity : '',
            validStudentQuantity: props.data.validStudentQuantity ? props.data.validStudentQuantity : false,
            isAvailableChecked: props.data.isAvailableChecked ? props.data.isAvailableChecked : false,
            taxesSelected: props.data.taxesSelected ? props.data.taxesSelected : [],
            planDescriptionDetails: props.data.planDescriptionDetails ? props.data.planDescriptionDetails : [], // Example: [{langCode: 'en', title: 'In english', description: 'In English desc'}]
            validDescriptions: props.data.validDescriptions ? props.data.validDescriptions : false,
            planAvailableIsos: props.data.planAvailableIsos ? props.data.planAvailableIsos : [],
            checkedValues: props.data.checkedValues ? props.data.checkedValues : [],
            checkedRegionsValues: props.data.checkedRegionsValues ? props.data.checkedRegionsValues : [],
            selectAll: props.data.selectAll ? props.data.selectAll : false,
            planSubmitEnabled: props.data.planSubmitEnabled ? props.data.planSubmitEnabled : false,
            loading: false,
            showModal: false,
            planId: props.data.planId ? props.data.planId : null,
            disabledGenerics: props.data.disabledGenerics,
            disabledPlanName: props.data.disabledPlanName,
            disabledPlanForSchools: props.data.disabledPlanForSchools,
            disabledPrivatePlan: props.data.disabledPrivatePlan,
            disabledProfilesQuantity: props.data.disabledProfilesQuantity,
            disabledPlanAvailability: props.data.disabledPlanAvailability,
            disabledPlanDescriptions: props.data.disabledPlanDescriptions,
            disabledRegionCountryIsos: props.data.disabledRegionCountryIsos,
            userData: props.data.userData
        };

        this.handlePlanCreated = this.handlePlanCreated.bind(this);
        this.handleClientCreated = this.handleClientCreated.bind(this);
        this.setStripePaymentToken = this.setStripePaymentToken.bind(this);
        this.evaluateIfFormCompleted = this.evaluateIfFormCompleted.bind(this);
        this.subscribeUser = this.subscribeUser.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.handleSubscriptionCancellationModal = this.handleSubscriptionCancellationModal.bind(this);
    }

    componentWillReceiveProps(props) {

        if (props.data.didMount) {
            this.setState({mobile: props.data.mobile});
        }
        this.setState({
            subscriptionId:
                typeof props.data.subscriptionId !== 'undefined' && props.data.subscriptionId !== null
                    ? props.data.subscriptionId: null,
            planId:
            typeof props.data.planId !== 'undefined' && props.data.planId !== null
                ? props.data.planId: null,
            userId:
                typeof props.data.userId !== 'undefined' && props.data.userId !== null
                    ? props.data.userId: null,
            isEdit:
                typeof props.data.isEdit !== 'undefined' && props.data.isEdit !== null
                    ? props.data.isEdit: false,
            isReadOnly: typeof props.data.isReadOnly !== 'undefined' && props.data.isReadOnly !== null
                ? props.data.isReadOnly: false,
            currencyIsoCode: props.data.currencyIsoCode ? props.data.currencyIsoCode : null,
            interval: props.data.interval ? props.data.interval : null,
            productId: props.data.productId ? props.data.productId : null,
            planName: props.data.planName ? props.data.planName : '',
            price: props.data.price ? props.data.price : null,
            validPrice: props.data.validPrice ? props.data.validPrice : false,
            tryPeriod: props.data.tryPeriod ? props.data.tryPeriod : null,
            isForSchoolChecked: props.data.isForSchoolChecked ? props.data.isForSchoolChecked : false,
            isPrivate: props.data.isPrivate ? props.data.isPrivate : false,
            studentQuantity: props.data.studentQuantity ? props.data.studentQuantity : '',
            validStudentQuantity: props.data.validStudentQuantity ? props.data.validStudentQuantity : false,
            isAvailableChecked: props.data.isAvailableChecked ? props.data.isAvailableChecked : false,
            taxesSelected: props.data.taxesSelected ? props.data.taxesSelected : [],
            planDescriptionDetails: props.data.planDescriptionDetails ? props.data.planDescriptionDetails : [], // Example: [{langCode: 'en', title: 'In english', description: 'In English desc'}]
            validDescriptions: props.data.validDescriptions ? props.data.validDescriptions : false,
            planAvailableIsos: props.data.planAvailableIsos ? props.data.planAvailableIsos : [],
            checkedValues: props.data.checkedValues ? props.data.checkedValues : [],
            checkedRegionsValues: props.data.checkedRegionsValues ? props.data.checkedRegionsValues : [],
            selectAll: props.data.selectAll ? props.data.selectAll : false,
            planSubmitEnabled: props.data.planSubmitEnabled ? props.data.planSubmitEnabled : false,
            loading: false,
            showModal: false,
            disabledGenerics: props.data.disabledGenerics,
            disabledPlanName: props.data.disabledPlanName,
            disabledPlanForSchools: props.data.disabledPlanForSchools,
            disabledPrivatePlan: props.data.disabledPrivatePlan,
            disabledProfilesQuantity: props.data.disabledProfilesQuantity,
            disabledPlanAvailability: props.data.disabledPlanAvailability,
            disabledPlanDescriptions: props.data.disabledPlanDescriptions,
            disabledRegionCountryIsos: props.data.disabledRegionCountryIsos,
            disabledAddress: props.data.disabledAddress,
            disabledName: props.data.disabledName,
            disabledPhoneNumber:  props.data.disabledPhoneNumber,
            disabledUsername:  props.data.disabledUsername,
            disabledPassword: props.data.disabledPassword,
            disabledEmail: props.data.disabledEmail,
            hideInsertion : props.data.hideInsertion,
            userData: typeof props.data.userData !== 'undefined'
            && props.data.userData !== null ? props.data.userData : null

        })
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    handleSubscriptionCancellationModal(){
        this.setState({showCancellationModal: true});
    }

    /**
     * Evaluates if the form is completed
     */
    evaluateIfFormCompleted() {
        if (this.state.userId === null || this.state.planId === null || this.state.subTokenStripe === null) {
            this.setState({
                submitButtonAvailable: false
            });
        }
        else {
            this.setState({
                submitButtonAvailable: true
            });
        }
    }

    handleClientCreated(data) {
        this.setState({
            userId: data.userId
        }, ()=> {
            this.evaluateIfFormCompleted();
        })
    }

    handlePlanCreated(data) {
        this.setState({
            planId: data.planId
        }, ()=> {
            this.evaluateIfFormCompleted();
        })
    }

    /**
     * Set the stripe payment token
     * @param field
     */
    setStripePaymentToken = (field) => (newValue) => {

        if (newValue == null)
            this.setState({
                subTokenStripe: null
            }, ()=> {
                this.evaluateIfFormCompleted();
            });
        else {
            this.setState({
                subTokenStripe: newValue.id
            }, ()=> {
                this.evaluateIfFormCompleted();
            });
        }
    };

    subscribeUser() {
        if (this.state.planId !== null && this.state.userId !== null && this.state.subTokenStripe !== null && this.state.submitButtonAvailable) {
            this.setState({loading: true, formCompleted: true});
            let apiCalls = ApiCalls.insertSubscriptionByEmployee(this.state.planId,
                this.state.userId,
                this.state.subTokenStripe);
            apiCalls.then((data)=> {
                let messageStr = '';
                for(let i=0; i < data.Messages.length;i++)
                {
                    messageStr += data.Messages[i] + '<br/>';
                }
                let propsModal = {
                    bodyText: messageStr,
                    visible: true
                };

                if(data.TransactionValid)
                {
                    this.setState({
                        subscriptionId: data.Subscriptions[0].SubscriptionId
                    });
                }

                this.setState({propsModal: propsModal, showModal: true, loading: false})
            });
        }
    }


    /**
     * Renders the full form
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <Row>
                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                        <Card body className="card-white">
                            <CardBody>
                                <FormRegistrationByAdmin data={this.state}
                                                         updateParent={this.handleClientCreated}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                        <Card body className="card-white">
                            <CardBody>
                                <Form>
                                    <FormGroupPlan data={this.state}
                                                   updateParent={this.handlePlanCreated}/>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <hr/>

                {!this.state.isEdit ?
                    <Row>

                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                            <Card body className="card-white">
                                <CardBody>
                                    <Form>
                                        <h2><b><Translate id="plan-creator.complete-payment"/></b></h2>
                                        <hr/>
                                        <Col lg={{size: 6}} md={{size: 7}} sm={{size: 12}} xs={{size: 12}}>
                                            <StripeProvider apiKey={this.state.stripeApiKey}>
                                                <Elements>
                                                    <CheckoutForm data={this.state.stripeUpdatePayment}
                                                                  updateParent={this.setStripePaymentToken()}/>
                                                </Elements>
                                            </StripeProvider>
                                        </Col>
                                        <Col lg={{size: 6}} md={{size: 7}} sm={{size: 12}} xs={{size: 12}}>
                                            {this.state.submitButtonAvailable ?
                                                <Button color="success" onClick={this.subscribeUser} block>
                                                    <Translate id="plan-creator.subscribe-user"/>
                                                </Button> : null }
                                        </Col>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> : null
                }

                <hr/>
                {this.state.subscriptionId !== null ?
                    <Row>
                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                            <Card body className="card-white">
                                <CardBody>
                                    <Form>
                                        <h2><b><Translate id="plan-creator.upload-users"/></b></h2>
                                        <hr/>
                                        <FileUploader subscriptionId={this.state.subscriptionId}
                                                      session={SessionManager.getSessionEmployee()}
                                                      students="1"/>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> : ''
                }
                <hr/>
                {this.state.isEdit ?
                    <Row>
                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                            <Button color="warning" onClick={this.handleSubscriptionCancellationModal}>
                                <Translate id="subscription-cancellation.title"/>
                            </Button>
                        </Col>
                    </Row> : null
                }
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}

                {this.state.showCancellationModal
                    ?
                    <ModalCancellationSubscription
                        disabled={this.state.disabledCancellation}
                        cancelAtPeriodEnd={this.state.cancelledInmediatetly}
                        subscriptionId={this.state.subscriptionId}
                        isEmployee={true}
                        visible={this.state.showCancellationModal} /> : null}
            </div>
        )
    };
}

export default withLocalize(FormSubscriptionCalculation);